import { ColumnHelper, RowData } from '@tanstack/react-table';

import { Checkbox, ICheckboxProps } from '../../Checkbox';
export const getSelectColumn = <Data extends RowData>(
    columnHelper: ColumnHelper<Data>,
    selectAllMode: 'all' | 'page' = 'all',
) => {
    return columnHelper.display({
        id: 'select',
        enableColumnFilter: false,
        enableSorting: false,
        enableResizing: false,
        enableHiding: false,
        size: 20,
        minSize: 20,
        maxSize: 20,
        meta: {
            disableRowLink: true,
            onCellClick: (_cell, e) => {
                e.stopPropagation();
            },
        },
        header: ({ table }) => {
            let value: ICheckboxProps['checked'] = false;
            if (table.getIsAllRowsSelected()) {
                value = true;
            } else if (table.getIsSomeRowsSelected()) {
                value = 'indeterminate';
            }

            return (
                <Checkbox
                    checked={value}
                    onCheckedChange={(state) => {
                        if (state === 'indeterminate') return;
                        selectAllMode === 'all'
                            ? table.toggleAllRowsSelected(state)
                            : table.toggleAllPageRowsSelected(state);
                    }}
                />
            );
        },
        cell: ({ row }) => {
            return (
                <Checkbox
                    disabled={!row.getCanSelect()}
                    checked={row.getIsSelected()}
                    onCheckedChange={(state) => {
                        if (state === 'indeterminate') return;
                        row.toggleSelected(state);
                    }}
                />
            );
        },
    });
};
